import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {VanBanDen} from '../../models/vanbanden/vanbanden';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {Message} from '../../models/danhmuc/message';
const apiUrl = `${environment.apiUrl}/api/info/vanbanden`;

@Injectable({
  providedIn: 'root'
})
export class VanBanDenService {
  constructor(public httpService: HttpClient) { }

  public getAll(): Observable<VanBanDen[]> {
    return this.httpService.get<VanBanDen[]>(`${apiUrl}/getall`).pipe(
      map(data => data.map(data => new VanBanDen().deserialize(data)))
    );
  }
  public add(params: Object): Observable<VanBanDen>
  {
    return this.httpService.post(`${apiUrl}/add`, params).pipe(
      map(data => new VanBanDen().deserialize(data)));

  }
  public update(params: Object): Observable<VanBanDen>
  {
    return this.httpService.post(`${apiUrl}/update`, params).pipe(
      map(data => new VanBanDen().deserialize(data)));

  }
  public changeThoiHan(id: number, thoiHan: string): Observable<VanBanDen>
  {
    return this.httpService.get(`${apiUrl}/changethoihan?id=${id}&thoihan=${thoiHan}`).pipe(
      map(data => new VanBanDen().deserialize(data)));

  }
  public getCountByKeyword(keyword: string, maLoaiVB: number, maLinhVuc: number, status: string, phoCap: number, nguoiNhapId: number,
                           nguoiChuTriId: number, maNoiGui: number, fromDate: string, toDate: string)
  {
    return this.httpService.get(`${apiUrl}/getcountbykeyword?keyword=${keyword}&mlvb=${maLoaiVB}&mlv=${maLinhVuc}&status=${status}`
                                    +`&phocap=${phoCap}&nhapid=${nguoiNhapId}&chutriid=${nguoiChuTriId}&noiguiid=${maNoiGui}&frdate=${fromDate}&todate=${toDate}`).pipe(
      map(data => Number(data)));
  }
  public getCountBySearch(staffId: number, keyword: string, soVanBan: string, maLoaiVanBan: number, maLinhVuc: number, status: string, maNoiGui: string, fromDate: string, toDate: string)
  {
    return this.httpService.get(`${apiUrl}/getcountbysearch?stid=${staffId}&keyword=${keyword}&svb=${soVanBan}&mlvb=${maLoaiVanBan}&mlv=${maLinhVuc}&status=${status}`
      +`&ngid=${maNoiGui}&frdate=${fromDate}&todate=${toDate}`).pipe(
      map(data => Number(data)));
  }

  public getCountByXLKeyword(keyword: string, maLoaiVB: number, maLinhVuc: number, status: string, phoCap: number, nguoiXuLy: number,
                           nguoiChuTriId: number, maNoiGui: number, xem: number, fromDate: string, toDate: string)
  {
    return this.httpService.get(`${apiUrl}/getcountbyxlkeyword?keyword=${keyword}&mlvb=${maLoaiVB}&mlv=${maLinhVuc}&st=${status}`
      +`&pc=${phoCap}&xlid=${nguoiXuLy}&cid=${nguoiChuTriId}&ngid=${maNoiGui}&xe=${xem}&frdate=${fromDate}&todate=${toDate}`).pipe(
      map(data => Number(data)));
  }
  public getById(id: number): Observable<VanBanDen>
  {
    return this.httpService.get<VanBanDen>(`${apiUrl}/findbyid/${id}`).pipe(
      map(data => new VanBanDen().deserialize(data)),
      catchError(() => throwError('items not found'))
    );
  }
  public delete(id: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/delete/${id}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id delete not found'))
    );
  }

  findByKeyword(keyword: String): Observable<VanBanDen[]> {
    return this.httpService.get<VanBanDen[]>(`${apiUrl}/findbykeyword?keyword=${keyword}`).pipe(
      map(data => data.map(data => new VanBanDen().deserialize(data)))
    );
  }
  findAllByPaging(keyword: String, maLoaiVB: number, maLinhVuc: number, status: string, phoCap: number, nguoiNhapId: number,
                  nguoiChuTriId: number, maNoiGui: number, fromDate: string, toDate: string, page: number, size: number): Observable<VanBanDen[]> {
    return this.httpService.get<VanBanDen[]>(`${apiUrl}/getallpaging?key=${keyword}&mlvb=${maLoaiVB}&mlv=${maLinhVuc}&status=${status}`
                                          +`&phocap=${phoCap}&nhapid=${nguoiNhapId}&chutriid=${nguoiChuTriId}&noiguiid=${maNoiGui}&frdate=${fromDate}&todate=${toDate}&page=${page}&size=${size}`).pipe(
      map(data => data.map(data => new VanBanDen().deserialize(data)))
    );
  }
  findAllByPagingSearch(staffId: number, keyword: string, soVanBan: string, maLoaiVanBan: number, maLinhVuc: number, status: string, maNoiGui: string, fromDate: string, toDate: string, page: number, size: number): Observable<VanBanDen[]> {
    return this.httpService.get<VanBanDen[]>(`${apiUrl}/getallpagingsearch?stid=${staffId}&key=${keyword}&svb=${soVanBan}&mlvb=${maLoaiVanBan}&mlv=${maLinhVuc}&status=${status}`
      +`&ngid=${maNoiGui}&frdate=${fromDate}&todate=${toDate}&page=${page}&size=${size}`).pipe(
      map(data => data.map(data => new VanBanDen().deserialize(data)))
    );
  }
  findAllByXLPaging(keyword: String, maLoaiVB: number, maLinhVuc: number, status: string, phoCap: number, nguoiXuLy: number,
                  nguoiChuTriId: number, maNoiGui: number, xem: number, fromDate: string, toDate: string,  page: number, size: number): Observable<VanBanDen[]> {
    return this.httpService.get<VanBanDen[]>(`${apiUrl}/getallxlpaging?key=${keyword}&mlvb=${maLoaiVB}&mlv=${maLinhVuc}&st=${status}`
      +`&pc=${phoCap}&xlid=${nguoiXuLy}&cid=${nguoiChuTriId}&ngid=${maNoiGui}&xe=${xem}&frdate=${fromDate}&todate=${toDate}&page=${page}&size=${size}`).pipe(
      map(data => data.map(data => new VanBanDen().deserialize(data)))
    );
  }
  findVanBanXLNext( status: string, phoCap: number, nguoiXuLy: number,
                    nguoiChuTriId: number, maNoiGui: number, xem: number): Observable<VanBanDen> {
    return this.httpService.get<VanBanDen>(`${apiUrl}/getvanbanxlnext?st=${status}`
      +`&pc=${phoCap}&xlid=${nguoiXuLy}&cid=${nguoiChuTriId}&ngid=${maNoiGui}&xe=${xem}`).pipe(
      map(data => new VanBanDen().deserialize(data)),
      catchError(() => throwError('items not found'))
    );
  }
  public addXuLy(id: number, uid: string, tht: number, tdc2: number, th: string, ctid: number, tt: number, ttvb: number, butPhe: string, nguoiGiaoId: number): Observable<VanBanDen>
  {
    return this.httpService.post(`${apiUrl}/addxuly?id=${id}&tht=${tht}&tdc2=${tdc2}&th=${th}&ctid=${ctid}&tt=${tt}&ttvb=${ttvb}&uids=${uid}&ngid=${nguoiGiaoId}`, butPhe).pipe(
      map(data => new VanBanDen().deserialize(data)));
  }
  public butPhe(id: number, ctid: number, butPhe: string): Observable<VanBanDen>
  {
    return this.httpService.post(`${apiUrl}/butphe?id=${id}&ctid=${ctid}`, butPhe).pipe(
      map(data => new VanBanDen().deserialize(data)));
  }
  public changePhoCap(id: string, phoCap: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/changephocap?id=${id}&pc=${phoCap}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id change not found'))
    );
  }
  public chenHoSo(id: number, hoSoId: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/chenhoso?id=${id}&hsid=${hoSoId}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id insert not found'))
    );
  }
}
